import { Button } from "@devhop/ui";

type OffsetPaginationBarProps = {
  offset: number;
  limit: number;
  total: number;
  onChange: (offset: number) => void;
  className?: string;
};

export function OffsetPaginationBar({
  offset,
  limit,
  total,
  onChange,
  className,
}: OffsetPaginationBarProps) {
  if (total <= limit) return null;

  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);
  const canPrev = offset > 0;
  const canNext = offset + limit < total;

  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-3 ${className ?? ""}`}
    >
      <p className="text-muted-foreground text-sm tabular-nums">
        ສະແດງ {from.toLocaleString("lo-LA")}–{to.toLocaleString("lo-LA")} ຈາກ{" "}
        {total.toLocaleString("lo-LA")}
      </p>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={!canPrev}
          onClick={() => onChange(Math.max(0, offset - limit))}
        >
          ກ່ອນໜ້າ
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={!canNext}
          onClick={() => onChange(offset + limit)}
        >
          ຖັດໄປ
        </Button>
      </div>
    </div>
  );
}

export const DEFAULT_PAGE_LIMIT = 20;
